import ApiService from './ApiService';

class AdminRepository extends ApiService {
  constructor() {
    super('');
  }

  async getAdminProfile(token: string) {
    return await this.post('/users/by-token', {
      accessToken: token,
    });
  }
}

export default new AdminRepository();
